import { useContext, useEffect, useState } from 'react';
import { SearchAPIKeyContext } from '@context/SearchAPIKeyProvider';
import { algoliaClient, initSearchClient } from '@general/helpers/search.helpers';

const useAlgoliaClient = () => {
    const [searchClient, setSearchClient] = useState();
    const { searchAPIKey } = useContext(SearchAPIKeyContext);

    useEffect(() => {
        const client = algoliaClient(searchAPIKey);
        setSearchClient(initSearchClient(client, true));
    }, [searchAPIKey]);

    return { searchClient };
};

export default useAlgoliaClient;
